import { Segment } from '@mi-front/core';
import { CreateFragmentDto, GetFragmentChunkDto, GetFragmentDto } from './fragment.types';

export type Fragment = GetFragmentDto;

export type FragmentChunk = GetFragmentChunkDto;

// type BaseCreateFragmentData = CreateFragmentDto & {
//   doExternalExport?: boolean;
//   platformUpload?: PartialRecord<
//     SocialPlatformId,
//     {
//       enabled: boolean;
//       config?: unknown;
//     }
//   >;
// };

export type CreateDefaultFragmentData = CreateFragmentDto & Pick<Fragment, 'from' | 'to'>;

/** Joint create payload: chunks must match the BFF create DTO, not GET fragment chunks. */
export type CreateJointFragmentData = Omit<CreateFragmentDto, 'chunks'> & {
  chunks: NonNullable<CreateFragmentDto['chunks']>;
};

export type DisplayableChunk = FragmentChunk & {
  color: string;
  segments: readonly Segment[];
};

export type DisplayableJointFragment = {
  chunks: DisplayableChunk[];
};

export function isSavedFragment(f: Fragment | DisplayableJointFragment): f is Fragment {
  return !!(f as Fragment).id;
}
